var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRankTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23120"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20212",
    style: {
      fill: "none"
    },
    d: "M0 0h100v152H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17888",
    d: "M7.84 135.44a167.988 167.988 0 0 0 19.04-15.75A107.965 107.965 0 0 0 43.4 99.88q6.86-10.64 6.86-20.3 0-6.02-3.36-9.52t-9.24-3.5a23.73 23.73 0 0 0-12.25 3.43 27.754 27.754 0 0 0-9.45 9.17L5.18 67.96a33.7 33.7 0 0 1 13.51-12.81A40.261 40.261 0 0 1 37.8 50.6q15.26 0 24.01 7.49t8.75 20.79q0 12.32-9.66 26.46t-26.32 29.68h39.34V150H7.84z",
    transform: "translate(10.32 -24.1)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: 4,
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankTwo);
export default __webpack_public_path__ + "static/media/rank-two.b7935577e8a6555b33e5c344128b8ced.svg";
export { ForwardRef as ReactComponent };